/**
 * Trunnion AI - Admin Page
 * /admin/* - Redirects to policies sub-route by default.
 */

import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { ROUTES } from '@/config/routes';

export default function AdminPage() {
  const navigate = useNavigate();
  const location = useLocation();

  // Redirect /admin to /admin/policies
  useEffect(() => {
    if (location.pathname === ROUTES.ADMIN || location.pathname === ROUTES.ADMIN + '/') {
      navigate(ROUTES.ADMIN_POLICIES, { replace: true });
    }
  }, [location.pathname, navigate]);

  return <AdminLayout />;
}
